import type { DashboardResponse } from '@/lib/api';
import type { UseHasNoSessionsParams } from '@/services/onboarding/onboarding.types';
import { useQuery } from '@tanstack/react-query';

/** Scoped per auth account, like the onboarding status. */
export const hasNoSessionsQueryKey = (accountId: string | null) => ['onboarding-has-no-sessions', accountId] as const;

const fetchHasNoSessions = async (): Promise<boolean> => {
  const response = await fetch('/api/sessions/dashboard?page=1&page_size=1', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Failed to count sessions');
  const body: DashboardResponse = await response.json();
  return body.pagination.total === 0;
};

/** Whether the person has never had a session: only they are new enough for the first-run tour. */
export const useHasNoSessions = ({ accountId, enabled }: UseHasNoSessionsParams) =>
  useQuery({
    queryKey: hasNoSessionsQueryKey(accountId),
    queryFn: fetchHasNoSessions,
    enabled,
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
